<template>
  <div class="radar-container">
    <div class="title-box">
      <div class="title-left">
        <div class="sign"></div>
        <span>{{ title || "雷达图" }}</span>
      </div>
      <div class="title-right"></div>
    </div>
    <div class="head-box">
      <div class="func-cell" @click="showPiker('code')">
        <span>{{ columns[selectIndex] }}</span
        ><i class="my-right" />
      </div>
    </div>
    <div class="body-box">
      <div class="views" id="map">
        <!--<img :src="viewsSrc" />-->
      </div>
      <div class="plays">
        <div class="slt-param">
          <div class="param-item" @click="showPiker('time')">
            <span>{{ startTime }}</span
            ><i class="i-right"></i>
          </div>
        </div>
        <div class="slt-view">
          <div
            class="img-tabs"
            v-for="(item, i) in mapdata"
            v-bind:key="i"
            @click="imgBtnClick(i)"
          >
            <img :src="item.imgurl" />
            <span :class="{ 'active-span': currimgbtn == i }">{{
              item.time
            }}</span>
          </div>
        </div>
        <div class="play-coms">
          <playbox
            ref="play"
            :btnIndex="currimgbtn"
            :mapData="mapdata"
            @changeIndex="changeBtnIndex"
          ></playbox>
        </div>
        <van-popup v-model="show" position="bottom">
          <van-picker
            v-if="popupkey == 'code'"
            show-toolbar
            :columns="columns"
            @cancel="show = false"
            @confirm="onConCodefirm"
            item-height="40"
            visible-item-count="3"
          />
          <van-datetime-picker
            v-if="popupkey == 'time'"
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            @cancel="show = false"
            @confirm="onConTimefirm"
            item-height="40"
            visible-item-count="3"
          />
        </van-popup>
      </div>
    </div>
    <mypopup :canclose="true" />
  </div>
</template>
<script>
import playbox from "@/components/playBox";
import mypopup from "@/components/my-popup";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
export default {
  name: "radar",
  components: {
    playbox,
    mypopup
  },
  data() {
    return {
      title: "",
      selectIndex: 0,
      mapIndex: 0,
      popupkey: "time",
      show: false,
      viewsSrc: "",
      currentDate: new Date(), //当前时间
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      startTime: this.$btools.fuc.formatDate(new Date(), "yyyy-MM-dd"), //查询起始时间
      endTime: this.$btools.fuc.formatDate(new Date(), "yyyy-MM-dd"), //查询结束时间
      currimgbtn: 0,
      currmap: "",
      currImgLayer: "",
      mapdata: [],
      markerlist: [],
      dropLatLon: [
        { center: [42.118716, 88.005445], zoom: 4, code: "" },
        { center: [44.14777778, 87.555], zoom: 6, code: "Z9081" }, // 五家渠
        { center: [39.87083333, 79.08583333], zoom: 6, code: "Z9082" }, // 图木舒克
        { center: [44.82722222, 82.34972222], zoom: 6, code: "Z9083" }, // 塔斯尔海 (博乐)
        { center: [37.02666667, 79.83222222], zoom: 6, code: "Z9903" }, // 和田
        { center: [45.28, 84.57], zoom: 6, code: "" }, // 克拉玛依机场
        { center: [43.91611111, 87.39277778], zoom: 6, code: "Z9991" }, // 乌鲁木齐
        { center: [44.28638889, 85.97611111], zoom: 6, code: "Z9993" }, // 石河子
        { center: [41.75972222, 86.20361111], zoom: 6, code: "Z9996" }, // 库尔勒
        { center: [41.16333333, 80.235], zoom: 6, code: "Z9997" }, // 阿克苏
        { center: [39.45972222, 76.0275], zoom: 6, code: "Z9998" }, // 喀什
        { center: [43.94222222, 81.32527778], zoom: 6, code: "Z9999" } // 伊宁
      ],
      columnsVal: [
        "0",
        "RAD_Z9081_RADDATA2_P",
        "RAD_Z9081_RADDATA2_P",
        "RAD_Z9082_RADDATA2_P",
        "RAD_Z9083_RADDATA2_P",
        "RAD_Z9903_RADDATA2_P",
        "RAD_Z9990_RADDATA2_P",
        "RAD_Z9991_RADDATA2_P",
        "RAD_Z9993_RADDATA2_P",
        "RAD_Z9996_RADDATA2_P",
        "RAD_Z9997_RADDATA2_P",
        "RAD_Z9998_RADDATA2_P",
        "RAD_Z9999_RADDATA2_P"
      ],
      columns: [
        "全部机场",
        "五家渠机场",
        "图木舒克机场",
        "塔斯尔海机场",
        "和田机场",
        "克拉玛依机场",
        "乌鲁木齐机场",
        "石河子机场",
        "库尔勒机场",
        "阿克苏机场",
        "喀什机场",
        "伊宁机场"
      ],
      //机场名称-雷达拼图marker标记
      airportlist: [
        { lat: 47.45, lon: 88.05, name: "阿勒泰", code: "ZWAT" },
        { lat: 38.09, lon: 85.32, name: "且末", code: "ZWCM" },
        { lat: 47.01, lon: 89.48, name: "富蕴", code: "ZWFY" },
        { lat: 41.43, lon: 82.59, name: "库车", code: "ZWKC" },
        { lat: 41.42, lon: 86.08, name: "库尔勒", code: "ZWKL" },
        { lat: 45.28, lon: 84.57, name: "克拉玛依", code: "ZWKM" },
        { lat: 39.33, lon: 76.01, name: "喀什", code: "ZWSH" },
        { lat: 46.4, lon: 83.21, name: "塔城", code: "ZWTC" },
        { lat: 37.02, lon: 79.52, name: "和田", code: "ZWTN" },
        { lat: 43.57, lon: 81.2, name: "伊宁", code: "ZWYN" },
        { lat: 42.78, lon: 93.44, name: "哈密", code: "ZWHM" },
        { lat: 43.41, lon: 83.27, name: "那拉提", code: "ZWNL" },
        { lat: 47.7, lon: 86.92, name: "喀纳斯", code: "ZWKN" },
        { lat: 38.25, lon: 77.06, name: "莎车", code: "ZWSC" },
        { lat: 38.97, lon: 88.01, name: "若羌", code: "ZWRQ" },
        { lat: 43.02, lon: 89.07, name: "吐鲁番", code: "ZWTL" },
        { lat: 44.9, lon: 82.02, name: "博乐", code: "ZWBL" },
        { lat: 39.53, lon: 79.14, name: "图木舒克", code: "ZWTS" },
        { lat: 41.16, lon: 80.17, name: "阿克苏温宿", code: "ZWAK" },
        { lat: 43.54, lon: 87.29, name: "乌鲁木齐地窝堡", code: "ZWWW" }
      ]
    };
  },
  mounted() {
    let that = this;
    that.getData();
    //that.makeTestData();
    // 地图加载，默认初始化的中心点为新疆全域中心（zoom缩放为4 效果相对最好）
    that.initMap(
      that.dropLatLon[that.selectIndex].center,
      that.dropLatLon[that.selectIndex].zoom
    );
  },
  watch: {
    mapdata(v) {
      if (v.length <= 0) {
        return;
      }
      const that = this;
      that.currimgbtn = 0;
      // 变更选项
      if (that.mapIndex !== that.selectIndex) {
        // 加载图片
        that.initImageToMap();
        if (that.selectIndex === 0) {
          // 加载非实况机场标记，有预警标识（20个）
          that.initMarkerItem();
        }
      } else {
        // 未变更选项
        if (that.currImgLayer === "") {
          // 避免相同机场查询不到结果时，缺少imglayer 实例。
          that.initImageToMap();
        }
        //修改图片地址（上一步initImageToMap是当前操作的前提）
        setTimeout(() => {
          that.setImgUrlToMap();
        }, 0);
      }
      // 所有操作完毕，保证当前视图最佳位置显示效果（中心点&缩放等级）
      that.setCenterZoom(
        that.dropLatLon[that.selectIndex].center,
        that.dropLatLon[that.selectIndex].zoom
      );
      this.mapIndex = this.selectIndex;
    },
    selectIndex(v) {
      const that = this;
      // 地图加载 （满足设置中心点及缩放等级）
      that.currmap.remove();
      that.initMap(
        that.dropLatLon[that.selectIndex].center,
        that.dropLatLon[that.selectIndex].zoom
      );
      if (v > 0) {
        // 加载当前机场位置标记
        that.addMarkerToMap(that.dropLatLon[that.selectIndex].center);
      }
      that.setCenterZoom(that.dropLatLon[v].center, that.dropLatLon[v].zoom);
    },
    currimgbtn() {
      if (this.currmap !== "") {
        this.setImgUrlToMap();
        if (this.selectIndex === 0) {
          this.initMarkerItem();
        }
      }
    }
  },
  methods: {
    //遮罩层显示隐藏及显示内容处理
    showPiker(k) {
      this.popupkey = k;
      this.show = true;
    },
    //时间按钮处理（样式），【点击按钮，如果处在播放状态，则进入暂停，转为点击切换显示图片】
    imgBtnClick(i) {
      this.$refs["play"].pauseing();
      this.currimgbtn = i;
    },
    //天气图code选择器确认
    onConCodefirm(value, index) {
      this.selectIndex = index;
      //code接口参数
      this.getData();
      this.show = false;
    },
    //气象数据公共时间选择器确认
    onConTimefirm() {
      let _date = this.$btools.fuc.formatDate(this.currentDate, "yyyy-MM-dd");
      this.startTime = _date;
      this.endTime = _date;
      this.show = false;
      this.getData();
    },
    // 子组件回调使用
    changeBtnIndex(idx) {
      this.currimgbtn = idx;
    },
    // 初始化地图 （leaflet-api）
    initMap(center, zm, fc) {
      var map = L.map("map").setView(center, zm);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: ""
      }).addTo(map);
      this.currmap = map;
      if (typeof fc === "function") {
        fc();
      }
    },
    // 修改中心点和缩放等级
    setCenterZoom(center, zm) {
      this.currmap.setView(center, zm);
    },
    // 映射图片 （leaflet-api）
    initImageToMap() {
      const that = this;
      if (that.mapdata.length <= 0) {
        return;
      }
      //增添图片投影
      var url = that.mapdata[that.currimgbtn].imgurl; //imgsrc.img;
      // 70.0, 140.0, 15.0, 54.0,
      var bounds = L.latLngBounds(that.mapdata[that.currimgbtn].latlon); //[[15.0, 70.0],[54.0, 140.0]]);
      var _currImgLayer = L.imageOverlay(url, bounds, {
        opacity: 0.8
      }).addTo(that.currmap);
      that.currImgLayer = _currImgLayer;
      that.currmap.fitBounds(bounds);
    },
    // 新方式更换图片 （leaflet-api）
    setImgUrlToMap() {
      const that = this;
      if (that.mapdata.length <= 0) {
        return;
      }
      if ("imgurl" in that.mapdata[that.currimgbtn]) {
        //console.log("that.currImgLayer", that.currImgLayer);
        that.currImgLayer.setUrl(that.mapdata[that.currimgbtn].imgurl);
      }
    },
    // marker 加载 （leaflet-api）
    initMarkerItem() {
      const that = this;
      if (that.mapdata.length <= 0) {
        return;
      }
      //return;
      var LeafIcon = L.Icon.extend({
        options: {
          //shadowUrl: "static/marker/marker-shadow.png",
          iconSize: [20, 30],
          shadowSize: [50, 64],
          iconAnchor: [1, 27],
          shadowAnchor: [4, 62],
          popupAnchor: [10, -27]
        }
      });

      var warning = new LeafIcon({ iconUrl: require("./image/warning.gif") }),
        unwarning = new LeafIcon({ iconUrl: require("./image/moren.png") });

      var layers = [];
      let latlonarr = this.mapdata[this.currimgbtn].crdata;
      //移除marker
      for (var i = 0; i < this.markerlist.length; i++) {
        this.currmap.removeLayer(this.markerlist[i]);
      }
      this.markerlist = [];
      //缺少雷达反射强度的直接跳过，标记集合清空。
      //console.log("crdata:", latlonarr);
      if (latlonarr == null) {
        this.markerlist = [];
        return;
      }
      //添加marker
      for (let i = 0; i < latlonarr.length; i++) {
        let namearr = this.airportlist.filter(m => {
          return m.lat == latlonarr[i].lat && m.lon == latlonarr[i].lon;
        });
        var layer = L.marker([latlonarr[i].lat, latlonarr[i].lon], {
          icon: latlonarr[i].dbz > 30 ? warning : unwarning
        })
          .addTo(this.currmap)
          .bindPopup(namearr[0].name);
        layers.push(layer);
      }
      this.markerlist = layers;
    },
    // 添加marker标记
    addMarkerToMap(center) {
      const that = this;
      var LeafIcon = L.Icon.extend({
        options: {
          //shadowUrl: "static/marker/marker-shadow.png",
          iconSize: [20, 30],
          shadowSize: [50, 64],
          iconAnchor: [1, 27],
          shadowAnchor: [4, 62],
          popupAnchor: [10, -27]
        }
      });

      var unwarning = new LeafIcon({ iconUrl: require("./image/moren.png") });
      L.marker(center, {
        icon: unwarning
      })
        .addTo(that.currmap)
        .bindPopup(that.columns[that.selectIndex].split(" ")[1]);
    },
    // 获取雷达拼图（或单站雷达）数据
    getData() {
      const that = this;
      if (that.columnsVal[that.selectIndex] === "0") {
        that.getRadarPuzzle();
      } else {
        that.getRadarVapor();
      }
    },
    getRadarPuzzle() {
      const that = this;
      let _nowDate = this.$btools.fuc.formatDate(
        new Date(),
        "yyyy-MM-dd hh:mm:ss"
      );
      let _istody = this.startTime == _nowDate.split(" ")[0];
      const param = {
        user: that.$store.state.api_user,
        password: that.$store.state.api_password,
        version: 3,
        funversion: 3,
        typeCodes1: "rad_cr_raddata2_p", //实况
        typeCodes2: "rad_opflow_raddata2_p", //预报
        listCount1: 20,
        listCount2: 20
      };
      const _stringify =
        this.$qstring.stringify(param) +
        "&funname=weather/rad/GetDataListByTypeCodes&queryTime=" +
        this.startTime +
        "%20" +
        (_istody ? _nowDate.split(" ")[1] : "23:59:59");
      /*执行请求*/
      this.$http
        .get("/Services?" + _stringify)
        .then(r => {
          console.log("雷达拼图源数据：", r);
          that.realData(r["data"]);
        })
        .catch(e => {
          console.log("获取雷达图异常:", e);
        });
    },
    getRadarVapor() {
      const that = this;
      let _nowDate = this.$btools.fuc.formatDate(
        new Date(),
        "yyyy-MM-dd hh:mm:ss"
      );
      let _istody = this.startTime == _nowDate.split(" ")[0];
      const param = {
        user: that.$store.state.api_user,
        password: that.$store.state.api_password,
        version: 3,
        funversion: 1,
        typeCodes: that.columnsVal[that.selectIndex],
        listCount: 20
      };
      //2020-05-12 12:00:00
      const _stringify =
        this.$qstring.stringify(param) +
        "&funname=weather/rad/GetDataListByTypeCodesAndCount&queryTime=" +
        this.startTime +
        "%20" +
        (_istody ? _nowDate.split(" ")[1] : "23:59:59");
      /*执行请求*/
      this.$http
        .get("/Services?" + _stringify)
        .then(r => {
          console.log("单站雷达源数据：", r);
          that.realData(r["data"]);
        })
        .catch(e => {
          console.log("获取雷达图异常:", e);
        });
    },
    //筛选出页面需要的数据集
    realData(o) {
      //console.log("开始数据处理...");
      if (!o["Rows"]) {
        //console.log("没有可处理数据！Rows:", o["Rows"]);
        this.mapdata = [];
        return;
      }
      let result = [];
      let _findex = o["FieldName"].indexOf("FILEPATH_0");
      let _minlon = o["FieldName"].indexOf("MINLON_0");
      let _minlat = o["FieldName"].indexOf("MINLAT_0");
      let _maxlon = o["FieldName"].indexOf("MAXLON_0");
      let _maxlat = o["FieldName"].indexOf("MAXLAT_0");
      let _cr = o["FieldName"].indexOf("CR"); //雷达反射强度
      let _time = o["FieldName"].indexOf("PRODUCTTIME");

      let _Arr = o["Rows"];
      try {
        for (let x = 0; x < _Arr.length; x++) {
          if (Object.keys(_Arr[x]).length <= 1) {
            continue;
          }
          let a = _Arr[x][_time].split(" ");
          let b = a[1].split(":");
          let c = _Arr[x][_findex];
          c = c.replace(/172.17.28.3/g, "124.117.223.3");
          let _m = {
            date: a[0],
            time: b[0] + ":" + b[1],
            latlon: [
              [_Arr[x][_minlat], _Arr[x][_minlon]],
              [_Arr[x][_maxlat], _Arr[x][_maxlon]]
            ],
            crdata: _cr == -1 ? [] : JSON.parse(_Arr[x][_cr]),
            imgurl: c
          };
          result.push(_m);
        }
        this.mapdata = result;
        //console.log("处理前的数据：", o);
        //console.log("处理后的数据：", this.mapdata);
        //this.initMap();
      } catch (e) {
        //console.log("处理数据异常：", e);
      }
    },
    //模拟数据
    makeTestData() {
      this.realData({
        FieldName: [
          "ID",
          "PRODUCTTIME",
          "PRODUCTDESC",
          "TYPEDESC",
          "MINLON",
          "MAXLON",
          "MINLAT",
          "MAXLAT",
          "SATNAME",
          "PROJECTTYPE",
          "CHANNEL",
          "FILESIZE",
          "FILEMD5CHECKSUM",
          "FILEPATH"
        ],
        Rows: [
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511095625",
            "2020-05-11 09:56:25",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            202141,
            "a271a951e25a187119422140ba4e1080",
            "static/qixiang/1.png"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511095218",
            "2020-05-11 09:52:18",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            201389,
            "678a3b1c42923e7d955befb66e465bbe",
            "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1589535121639&di=2ce24ea58dd7b064932b1973866967a2&imgtype=0&src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F01214d56daadba6ac7252ce6ea2dcc.jpg%401280w_1l_2o_100sh.jpg"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511094556",
            "2020-05-11 09:45:56",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            200006,
            "53a73c76743f28975f63f457f0e0ed3d",
            "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2320393046,3779158434&fm=26&gp=0.jpg"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511094158",
            "2020-05-11 09:41:58",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            199330,
            "873f44a942515252d796a864499b100f",
            "http://172.17.28.3:10004/Services?user=admin&password=111&version=3&funname=weather/sat/GetDataByTypeCodeAndId&funversion=1&typeCode=SAT_FY4A_HDF_L_IR2_P2_ToM&id=FY4A_HDF_L_IR2_P2_ToM_20200511094158"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511093743",
            "2020-05-11 09:37:43",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            198769,
            "1f71226e6b10e5c56afb241d4407d049",
            "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1945558512,3388949498&fm=26&gp=0.jpg"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511093105",
            "2020-05-11 09:31:05",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            198016,
            "f31e2b84562f48d4292c13f744cfcff1",
            "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1483612059,4063377252&fm=26&gp=0.jpg"
          ]
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/index";
.radar-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  margin: 0 auto;
  .title-box {
    display: flex;
    flex-direction: row;
    height: 8%;
    //height: px2rem(58);
    width: 95%;
    .title-left {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      width: 32.5%;
      .sign {
        width: 3px;
        height: px2rem(16);
        background-image: linear-gradient(180deg, #fe5936 0%, #fca656 100%);
      }
      span {
        font-family: PingFangSC-Semibold;
        font-size: px2rem(18);
        color: #ffffff;
        margin-left: px2rem(4);
      }
    }
    .title-right {
      height: 100%;
      width: 67.5%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
    /*border: 1px solid violet;*/
  }
  .head-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    //height: px2rem(45);
    height: 8%;
    width: 95%;
    .func-cell {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: px2rem(44);
      width: 100%;
      background-image: linear-gradient(142deg, #2b2f34 0%, #2b2f33 100%);
      box-shadow: inset 0px 3px 6px 0px rgba(0, 0, 0, 0.24),
        inset 0px -2px 2px 0px rgba(255, 255, 255, 0.09);
      border-radius: px2rem(12);
      span {
        font-size: px2rem(16);
        color: #a0a2a4;
        margin-left: px2rem(17);
      }
      .my-right {
        border: solid rgb(151, 151, 151);
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 3px;
        margin-right: px2rem(19);
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
    }
  }
  .body-box {
    height: 82%;
    width: 95%;
    .views {
      display: flex;
      height: 50%;
      width: 100%;
      margin-top: 4%;
      // box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.24), -3px -2px 3px rgba(0, 0, 0, 0.29);
      box-shadow: 0px 4px 15px 0px #120300;
      border-radius: 4px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .plays {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 46%;
      margin-top: px2rem(13);
      .slt-param {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 13.3%;
        font-size: px2rem(14);
        color: #e02c00;
        border-bottom: 1px solid rgb(67, 67, 67);
        border-top: 1px solid rgb(67, 67, 67);
        span {
          white-space: nowrap;
        }
        .i-right {
          border: solid #e02c00;
          border-width: 0 2px 2px 0;
          display: inline-block;
          padding: 3px;
          margin-left: px2rem(10);
          margin-bottom: px2rem(5);
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
        }
      }
      .slt-view {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        overflow-x: scroll;
        height: 39%;
        width: 100%;
        .img-tabs {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: px2rem(67);
          margin-right: px2rem(12);
          img {
            height: px2rem(52);
            width: px2rem(67);
            margin-bottom: px2rem(6);
          }
          span {
            font-size: px2rem(12);
            color: #a3a3a3;
          }
          .active-span {
            color: #d82600;
          }
        }
        /*border:1px solid greenyellow;*/
      }
      .play-coms {
        height: 45%;
        width: 100%;
      }
    }
  }
  /deep/.leaflet-control-zoom.leaflet-bar.leaflet-control {
    visibility: hidden;
  }
  /deep/.leaflet-control-attribution.leaflet-control {
    visibility: hidden;
  }
}
</style>
